import { useAuthentication } from '@app/src/context/AuthenticationContext'
import { isAdminRole } from '@app/src/utils/rolePermissions'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import OrganizationSettingSwitch from './OrganizationSettingSwitch'

const AiScreeningToggle: React.FC = () => {
  const { formatMessage } = useIntl()
  const { role } = useAuthentication().scope
  const title = formatMessage({ id: 'general.aiScreening' })

  return (
    <Stack
      bgcolor="background.paper"
      borderRadius={2}
      p={4}
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems="flex-start"
      spacing={2}
    >
      <Stack spacing={0.5}>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {formatMessage({ id: 'aiScreening.toggle.description' })}
          {!isAdminRole(role) && ` ${formatMessage({ id: 'aiScreening.acceptance.adminOnly' })}`}
        </Typography>
      </Stack>
      <OrganizationSettingSwitch settingKey="aiScreeningEnabled" ariaLabel={title} />
    </Stack>
  )
}

export default AiScreeningToggle
